import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import axiosClient from "../../api/axios";

export default function ClinicalAffiliation() {
  const [settings, setSettings] = useState(null);
  const [affiliations, setAffiliations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      axiosClient.get("/api/our-partners/settings/").then((r) => setSettings(r.data.data)),
      axiosClient.get("/api/affiliations/").then((r) => setAffiliations(r.data.data || [])),
    ]).finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <section style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>
        <ClipLoader color="#0d6efd" size={80} />
      </section>
    );
  }

  if (!settings) return null;

  return (
    <section id="blog" className="our-blog-section ptb-100 gray-light-bg">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="section-heading text-center mb-5">
              <h2>{settings.affiliation_title}</h2>
              <p className="lead">{settings.affiliation_subtitle}</p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          {affiliations.map((affiliation) => (
            <div key={affiliation.id} className="col-md-4 mb-4">
              <div className="single-blog-card card border-0 shadow-sm h-100 d-flex flex-column">
                <div className="card-body d-flex flex-column h-100">
                  <h3 className="h5 card-title">{affiliation.title}</h3>
                  <div className="post-meta mb-2">
                    <p>{affiliation.subtitle}</p>
                  </div>
                  <p className="card-text text-dark">{affiliation.description}</p>
                  <div className="post-meta mb-2">
                    <p>{affiliation.pis}</p>
                  </div>
                  {affiliation.button_title && affiliation.slug ? (
                    <Link
                      to={`/our-partners/${affiliation.slug}`}
                      className="detail-link mt-auto"
                    >
                      {affiliation.button_title}
                      <span className="ti-arrow-right"></span>
                    </Link>
                  ) : null}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
